"use client"

import { Alert, Platform } from "react-native"
import * as Linking from "expo-linking"
import { FormattedMessage } from "react-intl"

import { Box } from "../Layout"
import { Button } from "../Button"
import { H3, P } from "../Typography"
import { Sheet } from "../Sheet"

export type ForceUpdateModalProps = {
  isOpen: boolean
  iosAppStoreUrl: string
  androidPlayStoreUrl: string
}

export const ForceUpdateModal = ({
  isOpen,
  iosAppStoreUrl,
  androidPlayStoreUrl,
}: ForceUpdateModalProps) => {
  const storeUrl =
    Platform.OS === "ios" ? iosAppStoreUrl : androidPlayStoreUrl

  const handleUpdatePress = async () => {
    try {
      const canOpen = await Linking.canOpenURL(storeUrl)
      if (canOpen) {
        await Linking.openURL(storeUrl)
      } else {
        Alert.alert(
          "Update Required",
          `Please visit the ${Platform.OS === "ios" ? "App Store" : "Play Store"} to update the app.\n\n${storeUrl}`,
        )
      }
    } catch {
      Alert.alert(
        "Update Required",
        `Please visit the ${Platform.OS === "ios" ? "App Store" : "Play Store"} to update the app.\n\n${storeUrl}`,
      )
    }
  }

  return (
    <Sheet
      show={isOpen}
      sheetDragDisabled={true}
      renderContent={() => {
        return (
          <Box className="flex items-center justify-center pb-6 g-4">
            <H3 className="text-center">
              <FormattedMessage id="onboarding.updateRequired.title" />
            </H3>
            <P className="text-center text-gray-600">
              <FormattedMessage id="onboarding.updateRequired.description" />
            </P>
          </Box>
        )
      }}
      renderFooter={() => {
        return (
          <Box className="flex items-center pt-3 g-2">
            <Button as="button" variant="primary" handlePress={handleUpdatePress}>
              <FormattedMessage id="onboarding.updateRequired.cta" />
            </Button>
          </Box>
        )
      }}
    />
  )
}
